import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';


export interface VisitModeMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface VisitModeMst {
    id?: any;
    tenantId: any;
   
    name:string;
    isActive:string;
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    
    parameters?: VisitModeMstParameter[];
    links?: any;
}
export abstract class VisitModeMstData {    
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<VisitModeMst[]>;
    abstract create(url: string, data: VisitModeMst): Observable<VisitModeMst[]>;
    abstract update(url: string, data: VisitModeMst): Observable<VisitModeMst>;

    abstract delete(url: string): Observable<any>;
}